(() => {
  const ROOT_ID = "SCS_cart_01";
  if (window.__SCS_CART_01_INITIALIZED__ && document.getElementById(ROOT_ID)) return;
  if (window.__SCS_CART_01_INITIALIZED__ && !document.getElementById(ROOT_ID)) {
    window.__SCS_CART_01_INITIALIZED__ = false;
  }

  let root = null;
  let refs = null;
  let bootstrapping = true;
  let closingCart = false;

  function ensureMount() {
    if (!document.body) return null;
    let mount = document.getElementById(ROOT_ID);
    if (!mount) {
      mount = document.createElement("div");
      mount.id = ROOT_ID;
      mount.className = "SCS_cart_01 is-closed SCS_cart_01__mount";
      mount.innerHTML = `
        <div class="SCS_cart_01__overlay" data-action="overlay-close"></div>
        <aside class="SCS_cart_01__drawer" role="dialog" aria-modal="true" aria-label="Your cart">
          <header class="SCS_cart_01__drawer-header">
            <h2 id="SCS_cart_01_title">Your Cart</h2>
            <button type="button" class="SCS_cart_01__icon-btn" data-action="close-cart" aria-label="Close cart">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M18.3 5.7a1 1 0 0 0-1.4 0L12 10.6 7.1 5.7a1 1 0 1 0-1.4 1.4l4.9 4.9-4.9 4.9a1 1 0 0 0 1.4 1.4l4.9-4.9 4.9 4.9a1 1 0 0 0 1.4-1.4l-4.9-4.9 4.9-4.9a1 1 0 0 0 0-1.4Z"></path>
              </svg>
            </button>
          </header>
          <div class="SCS_cart_01__drawer-content">
            <div class="SCS_cart_01__refresh-overlay" aria-hidden="true">
              <span class="SCS_cart_01__refresh-spinner" aria-hidden="true"></span>
            </div>
            <div id="SCS_cart_01_body" class="SCS_cart_01__drawer-body SCS_cart_01__empty-block"></div>
            <footer id="SCS_cart_01_footer" class="SCS_cart_01__drawer-footer SCS_cart_01__empty-block"></footer>
          </div>
        </aside>
      `;
      document.body.appendChild(mount);
    }
    return mount;
  }

  let activeCartFetch = null;
  let rebuyFetchPromise = null;
  let rebuyCartSignature = "";
  let rebuyLoadGeneration = 0;
  let rebuyCartRefreshTimer = null;
  let dealFetchPromise = null;
  let blockedRemovalTimer = null;
  let blockedRemovalInProgress = false;
  let lastRenderKey = "";
  const variantCompareCache = new Map();
  let lineItemCompareEnrichGen = 0;

  const state = {
    cart: null,
    loading: false,
    refreshing: false,
    detailsOpen: false,
    deal: {
      expanded: false,
      fit: "car",
      prices: { car: 10900, truck: 11900 },
      compareAts: { car: 17900, truck: 18900 },
      variantIds: { car: null, truck: null },
      product: null,
    },
    recommendations: [],
    rebuyLoading: false,
  };

  const cfg = window.SCS_CART_01_CONFIG || {};
  const REBUY_UPSELL_WIDGET_ID = String(cfg.rebuyWidgetId || 105665);
  const REBUY_DEAL_WIDGET_ID = String(cfg.rebuyDealWidgetId || 295798);
  const DEAL_SNAPSHOT_KEY = "SCS_cart_01_deal_snapshot";
  const BLOCKED_CART_PRODUCT_IDS = (Array.isArray(cfg.blockedProductIds)
    ? cfg.blockedProductIds
    : [9971677495588]
  ).map(Number);
  const FREE_SHIPPING_THRESHOLD = Number(cfg.freeShippingThreshold ?? 2000);
  const ASSETS = cfg.assetsBase || "https://scs-cart-prototype.vercel.app/assets";
  const SHOPIFY_FILES = "https://cdn.shopify.com/s/files/1/0732/5909/0212/files";
  const DEAL_FEATURE_ICONS = {
    "feat-heavy-duty": `${SHOPIFY_FILES}/feat-heavy-duty.png?v=1781261373`,
    "feat-non-slip": `${SHOPIFY_FILES}/feat-non-slip.svg?v=1781261373`,
    "feat-easy-clean": `${SHOPIFY_FILES}/feat-easy-clean.svg?v=1781261373`,
    "feat-waterproof": `${SHOPIFY_FILES}/feat-waterproof.svg?v=1781261373`,
    "feat-easy-install": `${SHOPIFY_FILES}/feat-easy-install.svg?v=1781261373`,
    "feat-multi-function": `${SHOPIFY_FILES}/feat-multi-function.svg?v=1781261373`,
  };
  const DEFAULT_DEAL_FEATURES = [
    { icon: "feat-heavy-duty", title: "Heavy-Duty Construction", desc: "Withstands even the most energetic pets with reinforced stitching and durable materials." },
    { icon: "feat-non-slip", title: "Non-Slip Backing", desc: "Stays in place during sudden stops and turns, ensuring your pet's safety and comfort." },
    { icon: "feat-easy-clean", title: "Easy To Clean", desc: "Effortlessly maintain a fresh, clean cover by simply wiping it down." },
    { icon: "feat-waterproof", title: "Waterproof Barrier", desc: "Keeps your seats dry and clean, no matter what surprises your pet has in store." },
    { icon: "feat-easy-install", title: "Easy Installation", desc: "No tools required - set up in under a minute with adjustable straps and anchors." },
    { icon: "feat-multi-function", title: "Multi-Function Design", desc: "Use as a hammock, bench cover, or cargo liner to suit your travel needs." },
  ];
  const ICON_SVG = {
    trash: `<svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display:block" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7.6 3.8H11.4C11.4 3.29609 11.1998 2.81282 10.8435 2.4565C10.4872 2.10018 10.0039 1.9 9.5 1.9C8.99609 1.9 8.51282 2.10018 8.1565 2.4565C7.80018 2.81282 7.6 3.29609 7.6 3.8ZM5.7 3.8C5.7 2.79218 6.10036 1.82563 6.81299 1.11299C7.52563 0.400356 8.49218 0 9.5 0C10.5078 0 11.4744 0.400356 12.187 1.11299C12.8996 1.82563 13.3 2.79218 13.3 3.8H18.05C18.302 3.8 18.5436 3.90009 18.7218 4.07825C18.8999 4.25641 19 4.49804 19 4.75C19 5.00196 18.8999 5.24359 18.7218 5.42175C18.5436 5.59991 18.302 5.7 18.05 5.7H17.2121L16.3704 15.523C16.2895 16.4715 15.8555 17.3552 15.1543 17.999C14.453 18.6429 13.5357 19.0001 12.5837 19H6.4163C5.46431 19.0001 4.54696 18.6429 3.84574 17.999C3.14452 17.3552 2.71052 16.4715 2.6296 15.523L1.7879 5.7H0.95C0.698044 5.7 0.456408 5.59991 0.278249 5.42175C0.100089 5.24359 0 5.00196 0 4.75C0 4.49804 0.100089 4.25641 0.278249 4.07825C0.456408 3.90009 0.698044 3.8 0.95 3.8H5.7ZM12.35 9.5C12.35 9.24804 12.2499 9.00641 12.0718 8.82825C11.8936 8.65009 11.652 8.55 11.4 8.55C11.148 8.55 10.9064 8.65009 10.7282 8.82825C10.5501 9.00641 10.45 9.24804 10.45 9.5V13.3C10.45 13.552 10.5501 13.7936 10.7282 13.9718C10.9064 14.1499 11.148 14.25 11.4 14.25C11.652 14.25 11.8936 14.1499 12.0718 13.9718C12.2499 13.7936 12.35 13.552 12.35 13.3V9.5ZM7.6 8.55C7.85196 8.55 8.09359 8.65009 8.27175 8.82825C8.44991 9.00641 8.55 9.24804 8.55 9.5V13.3C8.55 13.552 8.44991 13.7936 8.27175 13.9718C8.09359 14.1499 7.85196 14.25 7.6 14.25C7.34804 14.25 7.10641 14.1499 6.92825 13.9718C6.75009 13.7936 6.65 13.552 6.65 13.3V9.5C6.65 9.24804 6.75009 9.00641 6.92825 8.82825C7.10641 8.65009 7.34804 8.55 7.6 8.55ZM4.522 15.3615C4.56247 15.8359 4.77961 16.2779 5.13042 16.5998C5.48123 16.9218 5.94014 17.1003 6.4163 17.1H12.5837C13.0595 17.0998 13.518 16.9211 13.8684 16.5992C14.2188 16.2773 14.4357 15.8356 14.4761 15.3615L15.3045 5.7H3.6955L4.522 15.3615Z" fill="#A2A2A2"/></svg>`,
    plus: `<svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display:block" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect width="19" height="19" rx="3" fill="#F0F0F0"/><path d="M14.2857 10.7143H10.7143V14.2857C10.7143 14.4752 10.639 14.6568 10.5051 14.7908C10.3711 14.9247 10.1894 15 10 15C9.81056 15 9.62888 14.9247 9.49492 14.7908C9.36097 14.6568 9.28571 14.4752 9.28571 14.2857V10.7143H5.71429C5.52485 10.7143 5.34316 10.639 5.20921 10.5051C5.07526 10.3711 5 10.1894 5 10C5 9.81056 5.07526 9.62888 5.20921 9.49492C5.34316 9.36097 5.52485 9.28571 5.71429 9.28571H9.28571V5.71429C9.28571 5.52485 9.36097 5.34316 9.49492 5.20921C9.62888 5.07525 9.81056 5 10 5C10.1894 5 10.3711 5.07525 10.5051 5.20921C10.639 5.34316 10.7143 5.52485 10.7143 5.71429V9.28571H14.2857C14.4752 9.28571 14.6568 9.36097 14.7908 9.49492C14.9247 9.62888 15 9.81056 15 10C15 10.1894 14.9247 10.3711 14.7908 10.5051C14.6568 10.639 14.4752 10.7143 14.2857 10.7143Z" fill="#000"/></svg>`,
  };

  function toMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format((cents || 0) / 100);
  }

  function toBadgeMoney(cents) {
    return toMoney(cents).replace(/\.00$/, "");
  }

  function getLineItemUnitSaleCents(item) {
    return Number(item.final_price ?? item.discounted_price ?? item.price ?? 0);
  }

  function getDealVariantCompareFromState(variantId) {
    const id = Number(variantId);
    if (!id) return 0;

    const ids = getDealVariantIds();
    if (Number(ids.car) === id && state.deal.compareAts.car) {
      return Number(state.deal.compareAts.car);
    }
    if (Number(ids.truck) === id && state.deal.compareAts.truck) {
      return Number(state.deal.compareAts.truck);
    }

    const fromProduct = state.deal.product?.variants?.find((variant) => Number(variant.id) === id);
    if (fromProduct?.compare_at_price) return Number(fromProduct.compare_at_price);

    const stored = getStoredDealSnapshot();
    const fromStored = stored?.product?.variants?.find((variant) => Number(variant.id) === id);
    if (fromStored?.compare_at_price) return Number(fromStored.compare_at_price);

    return 0;
  }

  function getLineItemUnitCompareCents(item, saleCents = getLineItemUnitSaleCents(item)) {
    const candidates = [];

    const pushIfHigher = (value) => {
      const cents = Number(value) || 0;
      if (cents > saleCents) candidates.push(cents);
    };

    console.log("getLineItemUnitCompareCents", item.variant_id, item.compare_at_price, item.variant_compare_at_price, getDealVariantCompareFromState(item.variant_id));
    pushIfHigher(item.compare_at_price);
    pushIfHigher(item.variant_compare_at_price);

    const cached = variantCompareCache.get(Number(item.variant_id));
    if (cached?.compare_at_price) pushIfHigher(cached.compare_at_price);

    pushIfHigher(getDealVariantCompareFromState(item.variant_id));

    if (candidates.length) return Math.max(...candidates);

    const originalPrice = Number(item.original_price) || 0;
    if (originalPrice > saleCents) return originalPrice;

    return 0;
  }

  async function enrichLineItemComparePrices(cart = state.cart) {
    if (!cart?.items?.length) return;

    const generation = ++lineItemCompareEnrichGen;
    const variantIds = new Set();

    cart.items.forEach((item) => {
      const sale = getLineItemUnitSaleCents(item);
      const variantId = Number(item.variant_id);
      if (!variantId || variantCompareCache.has(variantId)) return;
      const hasTrueCompare =
        (Number(item.compare_at_price) || 0) > sale ||
        (Number(item.variant_compare_at_price) || 0) > sale ||
        getDealVariantCompareFromState(variantId) > sale;
      if (hasTrueCompare) return;
      variantIds.add(variantId);
    });

    if (!variantIds.size) return;

    await Promise.all(
      [...variantIds].map(async (variantId) => {
        try {
          const variant = await apiFetch(`/variants/${variantId}.js`, { cache: "no-store" });
          if (generation !== lineItemCompareEnrichGen) return;
          variantCompareCache.set(variantId, {
            compare_at_price: Number(variant.compare_at_price) || 0,
            price: Number(variant.price) || 0,
          });
        } catch {
          variantCompareCache.set(variantId, null);
        }
      })
    );

    if (generation === lineItemCompareEnrichGen) {
      render(true);
    }
  }

  function scheduleLineItemCompareEnrichment(cart = state.cart) {
    void enrichLineItemComparePrices(cart);
  }

  function htmlEscape(value) {
    return String(value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;");
  }

  function hasSeatCover(item) {
    const text = `${item?.product_title || ""} ${item?.handle || ""}`.toLowerCase();
    const keywords = ["seat cover", "seat-cover", "luxury seat"];
    return keywords.some((k) => text.includes(k));
  }

  function isGiftItem(item) {
    const title = (item?.product_title || "").toLowerCase();
    const hasGiftProp = Object.keys(item?.properties || {}).some((k) => k.toLowerCase().includes("gift"));
    const keywords = ["free gift", "warranty", "microfiber", "gift"];
    return hasGiftProp || item.final_price === 0 || keywords.some((k) => title.includes(k));
  }

  function getDealHandle() {
    return cfg.dealHandle || "petsuite-hard-bottom-dog-seat-protector-no-fur";
  }

  function getRebuyProductTitle(p) {
    return p?.title || p?.product_title || p?.name || "";
  }

  function getRebuyProductHandle(p) {
    return String(p?.handle || p?.product_handle || "").toLowerCase();
  }

  function isBlockedCartProduct(item) {
    if (!item) return false;
    if (BLOCKED_CART_PRODUCT_IDS.includes(Number(item.product_id))) return true;
    const title = String(item.product_title || getRebuyProductTitle(item) || "").toLowerCase();
    return title.includes("free returns") && title.includes("package protection");
  }

  function isDealCatalogProduct(product) {
    if (!product) return false;
    const dealHandle = getDealHandle().toLowerCase();
    const handle = String(product.handle || "").toLowerCase();
    if (handle && handle === dealHandle) return true;
    const title = String(product.title || "").toLowerCase();
    return title.includes("petsuite") && title.includes("seat protector");
  }

  function isDealCatalogRebuyProduct(p) {
    return isDealCatalogProduct({
      handle: getRebuyProductHandle(p),
      title: getRebuyProductTitle(p),
    });
  }

  function pickDealProductFromRebuyProducts(products) {
    if (!Array.isArray(products)) return null;
    const match = products.find(isDealCatalogRebuyProduct);
    return match ? normalizeRebuyDealProduct(match) : null;
  }

  function getExcludedUpsellVariantIds() {
    const ids = new Set((state.cart?.items || []).map((item) => Number(item.variant_id)));
    getKnownDealVariantIds().forEach((id) => ids.add(id));
    (state.deal.product?.variants || []).forEach((variant) => {
      if (variant.id) ids.add(Number(variant.id));
    });
    return ids;
  }

  function isUpsellExcludedRebuyProduct(p) {
    if (!p) return true;
    if (isBlockedCartProduct({ product_id: p.id || p.product_id, product_title: getRebuyProductTitle(p) })) {
      return true;
    }
    return isDealCatalogRebuyProduct(p);
  }

  function scheduleBlockedProductRemoval() {
    clearTimeout(blockedRemovalTimer);
    blockedRemovalTimer = setTimeout(() => {
      void removeBlockedCartItems();
    }, 120);
  }

  async function removeBlockedCartItems() {
    if (blockedRemovalInProgress || !state.cart?.items?.length) return;
    const lines = state.cart.items
      .map((item, index) => ({ item, line: index + 1 }))
      .filter(({ item }) => isBlockedCartProduct(item));
    if (!lines.length) return;

    blockedRemovalInProgress = true;
    try {
      for (const { line } of [...lines].reverse()) {
        await apiFetch("/cart/change.js", {
          method: "POST",
          body: JSON.stringify({ line, quantity: 0 }),
        });
      }
      await pullCartFromServer(true);
    } catch (err) {
      console.warn("[SCS_CART_01] blocked product removal failed:", err);
    } finally {
      blockedRemovalInProgress = false;
    }
  }

  function resolveDealFeatureIcon(icon) {
    if (!icon) return "";
    if (/^https?:\/\//i.test(icon)) return icon;
    const key = icon.startsWith("feat-") ? icon : `feat-${icon}`;
    return DEAL_FEATURE_ICONS[key] || DEAL_FEATURE_ICONS[icon] || `${ASSETS}/${icon}`;
  }

  function normalizeDealFeature(feature) {
    return {
      title: feature.title || "",
      desc: feature.desc || "",
      icon: resolveDealFeatureIcon(feature.icon || feature.iconKey),
    };
  }

  function getDealFeatures() {
    const handle = getDealHandle();
    const custom =
      cfg.dealFeaturesByHandle?.[handle] ||
      cfg.dealProducts?.[handle]?.features ||
      cfg.dealFeatures;
    const source = Array.isArray(custom) && custom.length ? custom : DEFAULT_DEAL_FEATURES;
    return source.map(normalizeDealFeature);
  }

  function getDealTitle() {
    const handle = getDealHandle();
    return (
      cfg.dealProducts?.[handle]?.title ||
      cfg.dealTitle ||
      state.deal.product?.title ||
      "PetSuite Back Seat Protector"
    );
  }

  function getDealImage() {
    const handle = getDealHandle();
    return (
      cfg.dealImageUrl ||
      cfg.dealProducts?.[handle]?.imageUrl ||
      state.deal.product?.featured_image ||
      `${ASSETS}/petsuite.png`
    );
  }

  function getDealVariantText(variant) {
    return [variant?.title, variant?.option1, variant?.option2, variant?.option3, variant?.public_title]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
  }

  function matchDealFitVariant(variants, fit) {
    if (!variants?.length) return null;
    const cfgLabels = cfg.dealFitLabels?.[fit];
    const truckLabels = cfg.dealFitLabels?.truck || ["truck"];
    const carLabels = cfg.dealFitLabels?.car || ["car", "suv"];

    const matchesLabels = (variant, labels) => {
      const text = getDealVariantText(variant);
      return labels.some((label) => text.includes(String(label).toLowerCase()));
    };

    if (Array.isArray(cfgLabels) && cfgLabels.length) {
      const match = variants.find((variant) => matchesLabels(variant, cfgLabels));
      if (match) return match;
    }

    if (fit === "truck") {
      const truckMatch = variants.find((variant) => matchesLabels(variant, truckLabels));
      if (truckMatch) return truckMatch;
    } else {
      const carMatch = variants.find((variant) => {
        const text = getDealVariantText(variant);
        const isTruck = truckLabels.some((label) => text.includes(String(label).toLowerCase()));
        return !isTruck && matchesLabels(variant, carLabels);
      });
      if (carMatch) return carMatch;
    }

    if (variants.length === 2) {
      return fit === "truck" ? variants[1] : variants[0];
    }
    if (variants.length === 1) return variants[0];
    return null;
  }

  function getDealDiscountCents() {
    const value = Number(cfg.dealDiscountCents);
    return Number.isFinite(value) && value > 0 ? value : 7000;
  }

  function syncDealVariantPricing(variant, fit) {
    const listPrice = Number(variant?.price) || 0;
    const stickerCompare = Number(variant?.compare_at_price) || 0;
    const cfgCompare = Number(cfg.dealCompareAts?.[fit]) || 0;
    const cfgSale = Number(cfg.dealPrices?.[fit]) || 0;
    const dealDiscount = getDealDiscountCents();
    const fitDefaults = {
      car: { compareAt: 17900, sale: 10900 },
      truck: { compareAt: 18900, sale: 11900 },
    };
    const defaults = fitDefaults[fit] || fitDefaults.car;

    if (cfgSale > 0 && cfgCompare > cfgSale) {
      return { sale: cfgSale, compareAt: cfgCompare };
    }

    if (stickerCompare > listPrice && listPrice > 0) {
      return { sale: listPrice, compareAt: stickerCompare };
    }

    const compareAt = cfgCompare || listPrice || defaults.compareAt;
    const sale = cfgSale > 0 ? cfgSale : Math.max(0, compareAt - dealDiscount);
    return { sale, compareAt: compareAt > sale ? compareAt : defaults.compareAt };
  }

  function syncDealPricingFromCartItem(item) {
    if (!item) return;
    const variantId = Number(item.variant_id);
    const ids = getDealVariantIds();
    let fit = null;
    if (Number(ids.car) === variantId) fit = "car";
    else if (Number(ids.truck) === variantId) fit = "truck";
    if (!fit) return;

    const sale = getLineItemUnitSaleCents(item);
    const compare = getLineItemUnitCompareCents(item, sale);
    if (sale > 0) state.deal.prices[fit] = sale;
    if (compare > sale) {
      state.deal.compareAts[fit] = compare;
      return;
    }
    if (sale > 0) {
      state.deal.compareAts[fit] = sale + getDealDiscountCents();
    }
  }

  function syncDealFromProduct(product) {
    if (!product?.variants?.length) return;
    const cfgMap = cfg.dealVariantIds || {};
    const variantIds = {
      car: cfgMap.car || state.deal.variantIds?.car || null,
      truck: cfgMap.truck || state.deal.variantIds?.truck || null,
    };

    const carVariant = matchDealFitVariant(product.variants, "car");
    const truckVariant = matchDealFitVariant(product.variants, "truck");
    if (!variantIds.car && carVariant) variantIds.car = carVariant.id;
    if (!variantIds.truck && truckVariant) variantIds.truck = truckVariant.id;

    state.deal.variantIds = variantIds;

    ["car", "truck"].forEach((fit) => {
      const variantId = variantIds[fit];
      if (!variantId) return;
      const variant = product.variants.find((v) => Number(v.id) === Number(variantId));
      if (!variant) return;
      const pricing = syncDealVariantPricing(variant, fit);
      state.deal.prices[fit] = pricing.sale;
      state.deal.compareAts[fit] = pricing.compareAt;
    });
  }

  function getStoredDealSnapshot() {
    try {
      const raw = localStorage.getItem(DEAL_SNAPSHOT_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      return data?.product?.variants?.length ? data : null;
    } catch {
      return null;
    }
  }

  function saveDealSnapshot() {
    if (!state.deal.product?.variants?.length) return;
    try {
      localStorage.setItem(
        DEAL_SNAPSHOT_KEY,
        JSON.stringify({
          product: state.deal.product,
          variantIds: state.deal.variantIds,
          prices: state.deal.prices,
          compareAts: state.deal.compareAts,
          fit: state.deal.fit,
        })
      );
    } catch (err) {
      console.warn("[SCS_CART_01] Could not save deal snapshot:", err);
    }
  }

  function restoreDealSnapshot() {
    const data = getStoredDealSnapshot();
    if (!data) return false;
    if (!isDealCatalogProduct(data.product)) {
      clearDealSnapshot();
      return false;
    }
    state.deal.product = data.product;
    if (data.variantIds) state.deal.variantIds = { ...state.deal.variantIds, ...data.variantIds };
    if (data.prices) state.deal.prices = data.prices;
    if (data.compareAts) state.deal.compareAts = data.compareAts;
    if (data.fit) state.deal.fit = data.fit;
    syncDealFromProduct(state.deal.product);
    return true;
  }

  function clearDealSnapshot() {
    try {
      localStorage.removeItem(DEAL_SNAPSHOT_KEY);
    } catch (err) {
      console.warn("[SCS_CART_01] Could not clear deal snapshot:", err);
    }
  }

  function setDealProduct(product) {
    if (!product?.variants?.length || !isDealCatalogProduct(product)) return false;
    state.deal.product = product;
    syncDealFromProduct(product);
    saveDealSnapshot();
    return true;
  }

  function getKnownDealVariantIds(cart = state.cart) {
    const ids = new Set();
    Object.values(cfg.dealVariantIds || {}).forEach((id) => {
      if (id) ids.add(Number(id));
    });
    Object.values(state.deal.variantIds || {}).forEach((id) => {
      if (id) ids.add(Number(id));
    });
    (state.deal.product?.variants || []).forEach((variant) => {
      if (variant.id) ids.add(Number(variant.id));
    });
    const stored = getStoredDealSnapshot();
    if (stored) {
      Object.values(stored.variantIds || {}).forEach((id) => {
        if (id) ids.add(Number(id));
      });
      (stored.product?.variants || []).forEach((variant) => {
        if (variant.id) ids.add(Number(variant.id));
      });
    }
    return ids;
  }

  function findDealCartItem(cart = state.cart) {
    if (!cart?.items?.length) return null;
    const ids = getKnownDealVariantIds(cart);
    for (const item of cart.items) {
      if (ids.has(Number(item.variant_id))) return item;
    }
    const handle = getDealHandle();
    if (handle) {
      const match = cart.items.find((item) => item.handle === handle);
      if (match) return match;
    }
    const stored = getStoredDealSnapshot();
    const storedHandle = stored?.product?.handle;
    if (storedHandle) {
      const match = cart.items.find((item) => item.handle === storedHandle);
      if (match) return match;
    }
    return null;
  }

  function syncDealFitFromCartItem(item) {
    if (!item?.variant_id) return;
    const variantId = Number(item.variant_id);
    const ids = getDealVariantIds();
    if (Number(ids.truck) === variantId) state.deal.fit = "truck";
    else if (Number(ids.car) === variantId) state.deal.fit = "car";
  }

  function detectFitFromSeatItems() {
    const seatItems = getSeatItems();
    if (!seatItems.length) return;
    const truckLabels = cfg.dealFitLabels?.truck || ["truck"];
    const hasTruck = seatItems.some((item) => {
      const text = [
        item.variant_title,
        ...(item.options_with_values || []).map((o) => String(o.value || "")),
        ...Object.values(item.properties || {}),
      ].filter(Boolean).join(" ").toLowerCase();
      return truckLabels.some((label) => text.includes(String(label).toLowerCase()));
    });
    state.deal.fit = hasTruck ? "truck" : "car";
  }

  async function resolveDealProductFromCart(cart = state.cart) {
    const dealItem = findDealCartItem(cart);
    if (!dealItem) return false;

    if (state.deal.product?.variants?.length) {
      syncDealFitFromCartItem(dealItem);
      saveDealSnapshot();
      return true;
    }

    if (!dealItem.handle) return false;
    try {
      const product = await apiFetch(`/products/${dealItem.handle}.js`, { cache: "no-store" });
      setDealProduct(product);
      syncDealFitFromCartItem(dealItem);
      saveDealSnapshot();
      return true;
    } catch (err) {
      console.warn("[SCS_CART_01] resolveDealProductFromCart failed:", err);
      return false;
    }
  }

  async function fetchDealProduct() {
    const handle = getDealHandle();
    if (!handle) return null;
    try {
      const product = await apiFetch(`/products/${handle}.js`, { cache: "no-store" });
      setDealProduct(product);
      return product;
    } catch (err) {
      console.warn("[SCS_CART_01] Could not load deal product:", handle, err);
      return null;
    }
  }

  function getDealVariantIds() {
    const cfgMap = cfg.dealVariantIds || {};
    return {
      car: cfgMap.car || state.deal.variantIds?.car || null,
      truck: cfgMap.truck || state.deal.variantIds?.truck || null,
    };
  }

  function getDealVariantId() {
    const ids = getDealVariantIds();
    return state.deal.fit === "truck" ? ids.truck : ids.car;
  }

  async function ensureDealVariantId() {
    let variantId = Number(getDealVariantId());
    if (variantId) return variantId;
    await fetchDealProduct();
    variantId = Number(getDealVariantId());
    return variantId || null;
  }

  async function apiFetch(path, options = {}) {
    const res = await fetch(path, {
      headers: { "Content-Type": "application/json" },
      ...options,
    });
    if (!res.ok) throw new Error(`Request failed: ${res.status}`);
    return res.json();
  }

  async function loadDealFromRebuyWidget(options = {}) {
    if (state.deal.product?.variants?.length && isDealCatalogProduct(state.deal.product)) {
      syncDealFromProduct(state.deal.product);
      return true;
    }

    if (dealFetchPromise) {
      await dealFetchPromise;
      return Boolean(state.deal.product?.variants?.length);
    }

    dealFetchPromise = (async () => {
      try {
        if (state.deal.product?.variants?.length && isDealCatalogProduct(state.deal.product)) {
          syncDealFromProduct(state.deal.product);
          return true;
        }

        ensureRebuyWidgetHost(REBUY_DEAL_WIDGET_ID);
        const widget = await waitForRebuyWidget(REBUY_DEAL_WIDGET_ID, 8000);
        if (!widget) return false;

        applyCartContextToWidget(widget);
        if (syncDealFromRebuyWidget()) return true;

        let products = await fetchProductsFromWidget(widget);
        if (!products.length) products = await fetchProductsFromRebuyApi(widget);
        if (!products.length) return false;

        if (state.deal.product?.variants?.length) {
          syncDealFromProduct(state.deal.product);
          return true;
        }

        const product = pickDealProductFromRebuyProducts(products);
        if (!product?.variants?.length) return false;

        setDealProduct(product);
        return true;
      } catch (err) {
        console.warn("[SCS_CART_01] loadDealFromRebuyWidget failed:", err);
        return false;
      } finally {
        dealFetchPromise = null;
      }
    })();

    let loaded = await dealFetchPromise;
    if (!loaded && !state.deal.product) {
      await fetchDealProduct();
      loaded = Boolean(state.deal.product?.variants?.length);
    }

    if (loaded && options.render !== false && getSeatItems().length) {
      render(true);
    }
    return loaded;
  }

  function scheduleDealLoad() {
    if (!state.cart || getSeatItems().length === 0) return;
    if (state.deal.product?.variants?.length && isDealCatalogProduct(state.deal.product)) return;
    void loadDealProductData(state.cart).then((product) => {
      if (product && getSeatItems().length) render(true);
    });
  }

  async function loadDealProductData(cart = state.cart) {
    if (state.deal.product?.variants?.length && isDealCatalogProduct(state.deal.product)) {
      syncDealFromProduct(state.deal.product);
      return state.deal.product;
    }
    if (restoreDealSnapshot()) {
      if (cart) {
        const dealItem = findDealCartItem(cart);
        if (dealItem) syncDealFitFromCartItem(dealItem);
        else detectFitFromSeatItems();
      }
      return state.deal.product;
    }
    if (cart && (await resolveDealProductFromCart(cart)) && isDealCatalogProduct(state.deal.product)) {
      return state.deal.product;
    }
    const fetched = await fetchDealProduct();
    if (fetched) {
      detectFitFromSeatItems();
      return fetched;
    }
    const loaded = await loadDealFromRebuyWidget({ render: false });
    if (loaded && isDealCatalogProduct(state.deal.product)) {
      detectFitFromSeatItems();
      return state.deal.product;
    }
    return null;
  }

  async function refreshCartData() {
    const cart = await apiFetch("/cart.js", { cache: "no-store" });
    if (!state.deal.product?.variants?.length) {
      await loadDealProductData(cart);
    }
    applyCartFromServer(cart);
    return cart;
  }

  async function pullCartFromServer(forceRender = true) {
    const cart = await apiFetch("/cart.js", { cache: "no-store" });
    applyCartFromServer(cart);
    if (forceRender) render(true);
    return cart;
  }

  function scheduleCartRefreshFromRebuy() {
    clearTimeout(rebuyCartRefreshTimer);
    rebuyCartRefreshTimer = setTimeout(() => {
      void pullCartFromServer(true).catch((err) => {
        console.warn("[SCS_CART_01] rebuy cart sync failed:", err);
      });
    }, 150);
  }

  function setRefreshUi() {
    if (!root) return;
    const isInitialLoad = shouldShowCartSkeleton();
    const isRefreshing = state.refreshing;
    root.classList.toggle("is-refreshing", isRefreshing);
    root.classList.toggle("is-loading", isInitialLoad);
    const drawer = root.querySelector(".SCS_cart_01__drawer");
    const overlay = root.querySelector(".SCS_cart_01__refresh-overlay");
    drawer?.setAttribute("aria-busy", isInitialLoad || isRefreshing ? "true" : "false");
    overlay?.setAttribute("aria-hidden", isRefreshing ? "false" : "true");
  }

  async function fetchCart(options = {}) {
    if (activeCartFetch) {
      await activeCartFetch;
      return state.cart;
    }

    const hasCart = cartHasVisibleItems();
    const silent = options.silent !== undefined ? options.silent : hasCart;

    if (!silent) {
      state.loading = true;
      render(true);
    } else {
      state.refreshing = true;
      setRefreshUi();
    }

    activeCartFetch = (async () => {
      try {
        await refreshCartData();
      } catch (err) {
        if (!silent) showToast("Could not load cart. Retrying...");
        console.error(err);
      } finally {
        state.loading = false;
        state.refreshing = false;
        setRefreshUi();
        render(true);
      }
    })();

    try {
      await activeCartFetch;
    } finally {
      activeCartFetch = null;
    }
    return state.cart;
  }

  function getLineNumber(item) {
    if (!state.cart?.items?.length || !item?.key) return 0;
    const idx = state.cart.items.findIndex((x) => x.key === item.key);
    return idx >= 0 ? idx + 1 : 0;
  }

  function setStepperLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      if (!btn.dataset.scsQtyContent) btn.dataset.scsQtyContent = btn.innerHTML;
      btn.disabled = true;
      btn.classList.add("is-loading");
      btn.innerHTML = '<span class="SCS_cart_01__qty-spinner" aria-hidden="true"></span>';
      return;
    }
    btn.disabled = false;
    btn.classList.remove("is-loading");
    if (btn.dataset.scsQtyContent) {
      btn.innerHTML = btn.dataset.scsQtyContent;
      delete btn.dataset.scsQtyContent;
    }
  }

  function setCheckoutLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.disabled = true;
      btn.classList.add("is-loading");
      btn.innerHTML = '<span class="SCS_cart_01__checkout-spinner" aria-hidden="true"></span><span>Processing...</span>';
      btn.setAttribute("aria-busy", "true");
      return;
    }
    btn.disabled = false;
    btn.classList.remove("is-loading");
    btn.removeAttribute("aria-busy");
    btn.innerHTML = "\ud83d\udd12 Secure Checkout";
  }

  function getCartSubtotalCents(cart = state.cart) {
    if (!cart) return 0;
    return cart.items_subtotal_price ?? cart.total_price ?? 0;
  }

  function cartHasVisibleItems(cart = state.cart) {
    return Boolean(cart?.items?.length || cart?.item_count);
  }

  function shouldShowCartSkeleton() {
    return state.loading && !cartHasVisibleItems();
  }

  function applyCartFromServer(cart) {
    state.cart = cart;
    scheduleBlockedProductRemoval();
    if (getSeatItems().length === 0) {
      state.deal.product = null;
      clearDealSnapshot();
    } else if (state.deal.product) {
      syncDealFromProduct(state.deal.product);
      const dealItem = findDealCartItem(cart);
      if (dealItem) {
        syncDealFitFromCartItem(dealItem);
        syncDealPricingFromCartItem(dealItem);
      } else {
        detectFitFromSeatItems();
      }
    } else {
      const dealItem = findDealCartItem(cart);
      if (dealItem) syncDealPricingFromCartItem(dealItem);
    }
    const sig = getRebuyCartSignature();
    if (sig !== rebuyCartSignature) {
      rebuyCartSignature = sig;
      rebuyLoadGeneration += 1;
      rebuyFetchPromise = null;
    }
    scheduleRebuyLoad({ force: true, showSkeleton: !state.recommendations.length });
    scheduleDealLoad();
    scheduleLineItemCompareEnrichment(cart);
  }

  async function changeLine(line, quantity, triggerBtn) {
    const isRemove = quantity <= 0;
    if (triggerBtn) setStepperLoading(triggerBtn, true);

    const snapshot = state.cart ? JSON.parse(JSON.stringify(state.cart)) : null;
    state.refreshing = true;
    setRefreshUi();

    try {
      if (isRemove) {
        const targetItem = state.cart?.items?.[line - 1];
        const targetGid = targetItem?.properties?._gid;

        await apiFetch("/cart/change.js", {
          method: "POST",
          body: JSON.stringify({ line, quantity }),
        });

        if (targetGid) {
          const cartAfterRemove = await apiFetch("/cart.js", { cache: "no-store" });
          const gidItems = (cartAfterRemove?.items || []).filter((item) => item?.properties?._gid === targetGid);
          if (gidItems.length) {
            const updates = {};
            gidItems.forEach((item) => {
              if (item?.key) updates[item.key] = 0;
            });

            if (Object.keys(updates).length) {
              await apiFetch("/cart/update.js", {
                method: "POST",
                body: JSON.stringify({ updates }),
              });
            }
          }
        }
      } else {
        await apiFetch("/cart/change.js", {
          method: "POST",
          body: JSON.stringify({ line, quantity }),
        });
      }
      await refreshCartData();
      render(true);
    } catch (err) {
      if (snapshot) {
        state.cart = snapshot;
        render(true);
      }
      showToast(isRemove ? "Unable to remove item." : "Unable to update quantity.");
      console.error(err);
    } finally {
      state.refreshing = false;
      setRefreshUi();
      if (triggerBtn) setStepperLoading(triggerBtn, false);
    }
  }

  async function postCartAdd(variantId, quantity, rebuyWidgetId) {
    const id = Number(variantId);
    const item = { id, quantity };
    if (rebuyWidgetId) {
      item.properties = { _widget_id: String(rebuyWidgetId) };
    }
    return apiFetch("/cart/add.js", {
      method: "POST",
      body: JSON.stringify({ items: [item] }),
    });
  }

  async function addVariant(variantId, quantity = 1, rebuyWidgetId) {
    const id = Number(variantId);
    if (!id) {
      showToast("Offer is not configured yet.");
      return;
    }
    try {
      await postCartAdd(id, quantity, rebuyWidgetId);
      await pullCartFromServer(true);
    } catch (err) {
      showToast("Unable to add this item right now.");
      console.error(err);
    }
  }

  function getVisibleItems() {
    if (!state.cart?.items?.length) return [];
    return state.cart.items.filter((item) => {
      const title = (item?.product_title || "").toLowerCase();
      if (title.includes("rebuy")) return false;
      if (isBlockedCartProduct(item)) return false;
      return true;
    });
  }

  function getSeatItems() {
    return getVisibleItems().filter(hasSeatCover);
  }

  function getGiftItemKey(item) {
    if (item?.variant_id) return `variant:${item.variant_id}`;
    if (item?.product_id) return `product:${item.product_id}`;
    const title = String(item?.product_title || "").toLowerCase().trim();
    const variant = String(item?.variant_title || "").toLowerCase().trim();
    return `title:${title}|${variant}`;
  }

  function getGiftItems() {
    const seen = new Set();
    return getVisibleItems().filter((item) => {
      if (!isGiftItem(item)) return false;
      const key = getGiftItemKey(item);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function getRegularItems() {
    return getVisibleItems().filter((x) => !isGiftItem(x));
  }

  function hasDealClaimed() {
    const ids = getKnownDealVariantIds();
    if (!ids.size) return false;
    return Boolean(state.cart?.items?.some((item) => ids.has(Number(item.variant_id))));
  }

  function getDealCartItem() {
    return findDealCartItem();
  }

  function buildVehicleMeta(item) {
    const entries = Object.entries(item.properties || {}).filter(([k, v]) => {
      return !k.startsWith("_") && String(v || "").trim().length > 0;
    });
    return entries.slice(0, 3).map(([k, v]) => `${k} : ${v}`);
  }

  function renderQtyDownButton(item) {
    const line = getLineNumber(item);
    if (item.quantity > 1) {
      return `<button type="button" class="SCS_cart_01__qty-btn SCS_cart_01__qty-btn--minus" data-action="qty-down" data-line="${line}" aria-label="Decrease quantity"><span class="SCS_cart_01__qty-minus-bar"></span></button>`;
    }
    return `<button type="button" class="SCS_cart_01__qty-btn SCS_cart_01__qty-btn--trash" data-action="qty-down" data-line="${line}" aria-label="Remove item">${ICON_SVG.trash}</button>`;
  }

  function isDefaultVariantTitle(value) {
    return String(value || "").trim().toLowerCase() === "default title";
  }

  function getLineItemVariantText(item) {
    const title = String(item?.variant_title || "").trim();
    if (title && !isDefaultVariantTitle(title)) return title;

    const fromOptions = (item?.options_with_values || [])
      .map((option) => String(option?.value || "").trim())
      .filter((value) => value && !isDefaultVariantTitle(value));
    return fromOptions.length ? fromOptions.join(" / ") : "";
  }

  function renderLineItem(item) {
    const line = getLineNumber(item);
    const unitSale = getLineItemUnitSaleCents(item);
    const unitCompare = getLineItemUnitCompareCents(item, unitSale);
    const unitDiscount = unitCompare > unitSale ? unitCompare - unitSale : 0;
    const meta = buildVehicleMeta(item);
    const variantText = getLineItemVariantText(item);
    const badge = unitDiscount > 0 ? `<span class="SCS_cart_01__badge">${htmlEscape(toBadgeMoney(unitDiscount))} OFF</span>` : "";

    return `
      <article class="SCS_cart_01__line-item" data-line="${line}">
        <img class="SCS_cart_01__line-item-img" src="${htmlEscape(item.image || item.featured_image?.url || "")}" alt="${htmlEscape(item.product_title)}">
        <div class="SCS_cart_01__line-item-main">
          <div class="SCS_cart_01__title-row">
            <p class="SCS_cart_01__name">${htmlEscape(item.product_title)}</p>
            <div class="SCS_cart_01__title-side">
              ${badge}
              <div class="SCS_cart_01__price-col">
                <span class="SCS_cart_01__sale">${toMoney(unitSale)}</span>
                ${unitCompare > unitSale ? `<span class="SCS_cart_01__compare">${toMoney(unitCompare)}</span>` : ""}
              </div>
            </div>
          </div>
          ${variantText ? `<p class="SCS_cart_01__variant">${htmlEscape(variantText)}</p>` : ""}
          ${meta.length ? `<div class="SCS_cart_01__meta">${meta.map((entry) => `<span>${htmlEscape(entry)}</span>`).join("")}</div>` : ""}
          <div class="SCS_cart_01__qty">
            ${renderQtyDownButton(item)}
            <strong class="SCS_cart_01__qty-val">${item.quantity}</strong>
            <button type="button" class="SCS_cart_01__qty-btn SCS_cart_01__qty-btn--plus" data-action="qty-up" data-line="${line}" aria-label="Increase quantity">${ICON_SVG.plus}</button>
          </div>
        </div>
      </article>
      <hr class="SCS_cart_01__line-sep">
    `;
  }

  function renderGiftCard(item) {
    const img = item.image || item.featured_image?.url || "";
    const compareVal = item.original_price || item.line_price || item.final_price || 0;
    const variantText = getLineItemVariantText(item);
    const displayName = variantText && !item.product_title.includes(variantText)
      ? `${item.product_title} | ${variantText}`
      : item.product_title;

    return `
      <div class="SCS_cart_01__gift-card">
        <div class="SCS_cart_01__gift-img-wrap">
          <img class="SCS_cart_01__gift-img" src="${htmlEscape(img)}" alt="${htmlEscape(displayName)}">
        </div>
        <div class="SCS_cart_01__gift-details">
          <p class="SCS_cart_01__gift-label">Your Free Gift</p>
          <p class="SCS_cart_01__gift-name">${htmlEscape(displayName)}</p>
          <div class="SCS_cart_01__gift-bottom">
            <p class="SCS_cart_01__gift-price-free"><s>${toMoney(compareVal)}</s> <span class="free">FREE</span></p>
            <div class="SCS_cart_01__gift-claim">
              <span class="SCS_cart_01__gift-claim-label">Claimed</span>
              <div class="SCS_cart_01__gift-checkbox">
                <img src="${ASSETS}/icon-check.svg" alt="Claimed" width="15" height="11">
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function dealClaimInner(claimed, loading = false) {
    const labelClass = claimed
      ? "SCS_cart_01__deal-claim-label--active"
      : "SCS_cart_01__deal-claim-label--inactive";
    const labelText = claimed ? "Claimed" : "Claim Deal";
    const label = `<span class="SCS_cart_01__deal-claim-label ${labelClass}">${labelText}</span>`;

    if (loading) {
      return `${label}<div class="SCS_cart_01__deal-checkbox SCS_cart_01__deal-checkbox--loading"><span class="SCS_cart_01__qty-spinner" aria-hidden="true"></span></div>`;
    }

    const box = claimed
      ? `<div class="SCS_cart_01__deal-checkbox SCS_cart_01__deal-checkbox--claimed"><img src="${ASSETS}/icon-check.svg" alt="Claimed" width="15" height="11"></div>`
      : `<div class="SCS_cart_01__deal-checkbox SCS_cart_01__deal-checkbox--unclaimed"></div>`;
    return label + box;
  }

  function renderDealFeatures() {
    const features = getDealFeatures();
    const col1 = features.slice(0, 3)
      .map(
        (f) => `
        <div class="SCS_cart_01__deal-feat-tile">
          <div class="SCS_cart_01__deal-feat-icon"><img src="${f.icon}" alt="${htmlEscape(f.title)}"></div>
          <p class="SCS_cart_01__deal-feat-title">${htmlEscape(f.title)}</p>
          <p class="SCS_cart_01__deal-feat-desc">${htmlEscape(f.desc)}</p>
        </div>`
      )
      .join("");
    const col2 = features.slice(3)
      .map(
        (f) => `
        <div class="SCS_cart_01__deal-feat-tile">
          <div class="SCS_cart_01__deal-feat-icon"><img src="${f.icon}" alt="${htmlEscape(f.title)}"></div>
          <p class="SCS_cart_01__deal-feat-title">${htmlEscape(f.title)}</p>
          <p class="SCS_cart_01__deal-feat-desc">${htmlEscape(f.desc)}</p>
        </div>`
      )
      .join("");
    return `
      <div class="SCS_cart_01__deal-features-grid">
        <div class="SCS_cart_01__deal-features-col">${col1}</div>
        <div class="SCS_cart_01__deal-features-col">${col2}</div>
      </div>`;
  }

  function syncDealDom() {
    const card = root?.querySelector("#SCS_cart_01_deal-card");
    if (!card) return;
    card.classList.toggle("is-expanded", state.deal.expanded);
    const toggle = root.querySelector("#SCS_cart_01_deal-toggle");
    if (toggle) toggle.textContent = state.deal.expanded ? "Show Less" : "Learn More";
  }

  function syncDealClaimDom(claimed, loading = false) {
    const isClaimed = claimed !== undefined ? claimed : hasDealClaimed();
    const html = dealClaimInner(isClaimed, loading);
    root?.querySelectorAll(".SCS_cart_01__deal-claim-row").forEach((el) => {
      el.innerHTML = html;
      el.disabled = loading;
      el.classList.toggle("is-loading", loading);
      el.setAttribute("aria-busy", loading ? "true" : "false");
    });
  }

  async function toggleDealClaim() {
    const claimRows = root?.querySelectorAll(".SCS_cart_01__deal-claim-row");
    if (claimRows?.[0]?.disabled) return;

    const wasClaimed = hasDealClaimed();
    syncDealClaimDom(wasClaimed, true);

    try {
      if (wasClaimed) {
        const item = getDealCartItem();
        const line = getLineNumber(item);
        if (!line) {
          showToast("Unable to remove deal from cart.");
          return;
        }
        await apiFetch("/cart/change.js", {
          method: "POST",
          body: JSON.stringify({ line, quantity: 0 }),
        });
        await fetchCart({ silent: true });
      } else {
        const variantId = await ensureDealVariantId();
        const id = Number(variantId);
        if (!id) {
          showToast("Offer is not configured yet.");
          return;
        }
        await postCartAdd(id, 1, REBUY_DEAL_WIDGET_ID);
        await fetchCart({ silent: true });
        state.deal.expanded = false;
        syncDealDom();
      }
      render(true);
    } catch (err) {
      showToast(wasClaimed ? "Unable to remove deal." : "Unable to add deal.");
      console.error(err);
    } finally {
      syncDealClaimDom(undefined, false);
    }
  }

  function renderShippingBanner() {
    const subtotal = getCartSubtotalCents();
    const unlocked = subtotal >= FREE_SHIPPING_THRESHOLD;

    if (unlocked) {
      return `
        <section class="SCS_cart_01__shipping-banner SCS_cart_01__shipping-banner--unlocked">
          <p class="SCS_cart_01__shipping-banner-text">Congrats! You Unlocked FREE Standard Shipping</p>
          <div class="SCS_cart_01__shipping-track"><div class="SCS_cart_01__shipping-bar"></div></div>
        </section>`;
    }

    const away = Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal);
    const progress = subtotal <= 0 ? 4 : Math.max(4, Math.min(100, Math.round((subtotal / FREE_SHIPPING_THRESHOLD) * 100)));
    return `
      <section class="SCS_cart_01__shipping-banner SCS_cart_01__shipping-banner--progress">
        <p class="SCS_cart_01__shipping-banner-headline">Good choice! Your selection is being reserved.</p>
        <div class="SCS_cart_01__shipping-track"><div class="SCS_cart_01__shipping-bar" style="width:${progress}%"></div></div>
        <p class="SCS_cart_01__shipping-banner-sub">You are ${toMoney(away)} away from <strong>FREE SHIPPING</strong></p>
      </section>`;
  }

  function renderDealSection() {
    if (getSeatItems().length === 0) return "";
    const claimed = hasDealClaimed();
    const discount = Math.max(0, state.deal.compareAts[state.deal.fit] - state.deal.prices[state.deal.fit]);
    const carClass = state.deal.fit === "car" ? "is-active" : "is-inactive";
    const truckClass = state.deal.fit === "truck" ? "is-active" : "is-inactive";
    const claimHtml = dealClaimInner(claimed);
    const dealTitle = getDealTitle();
    const dealImage = getDealImage();

    return `
      <section class="SCS_cart_01__deal-card ${state.deal.expanded ? "is-expanded" : ""}" id="SCS_cart_01_deal-card">
        <div class="SCS_cart_01__deal-top">
          <img class="SCS_cart_01__deal-img" src="${htmlEscape(dealImage)}" alt="${htmlEscape(dealTitle)}">
          <div class="SCS_cart_01__deal-details">
            <div class="SCS_cart_01__deal-chip">
              <img src="${ASSETS}/icon-thunder.svg" alt="" width="11" height="18">
              <span class="SCS_cart_01__deal-chip-text"> Deal Unlocked - Get ${toMoney(discount)} Off</span>
            </div>
            <p class="SCS_cart_01__deal-name">${htmlEscape(dealTitle)}</p>
            <div class="SCS_cart_01__fit-row">
              <button type="button" class="SCS_cart_01__fit-chip ${carClass}" data-action="set-fit" data-fit="car">Car or SUV</button>
              <button type="button" class="SCS_cart_01__fit-chip ${truckClass}" data-action="set-fit" data-fit="truck">Truck</button>
              <button type="button" class="SCS_cart_01__deal-toggle" id="SCS_cart_01_deal-toggle" data-action="toggle-deal">${state.deal.expanded ? "Show Less" : "Learn More"}</button>
            </div>
            <div class="SCS_cart_01__deal-price-claim-row">
              <p class="SCS_cart_01__deal-price"><s>${toMoney(state.deal.compareAts[state.deal.fit])}</s><span class="sale"> ${toMoney(state.deal.prices[state.deal.fit])}</span></p>
              <button type="button" class="SCS_cart_01__deal-claim-row SCS_cart_01__deal-claim--inline" data-action="claim-deal">${claimHtml}</button>
            </div>
          </div>
        </div>
        <div class="SCS_cart_01__deal-features">${renderDealFeatures()}</div>
        <div class="SCS_cart_01__deal-claim-bottom">
          <button type="button" class="SCS_cart_01__deal-claim-row" data-action="claim-deal">${claimHtml}</button>
        </div>
      </section>
    `;
  }

  function getSavingsRows() {
    const rows = [];
    const cart = state.cart;
    if (!cart) return "";
    rows.push(`<div class="SCS_cart_01__detail-row"><span>Sub Total</span><span>${toMoney(cart.original_total_price || cart.total_price || 0)}</span></div>`);
    const lineSavings = (cart.original_total_price || 0) - (cart.total_price || 0);
    rows.push(`<div class="SCS_cart_01__detail-row"><span style="color: var(--red)">Discount</span><span class="SCS_cart_01__detail-neg" style="color: var(--red)">- ${toMoney(lineSavings)}</span></div>`);
    (cart.cart_level_discount_applications || []).forEach((d) => {
      rows.push(`<div class="SCS_cart_01__detail-row"><span>${htmlEscape(d.title)}</span><span class="SCS_cart_01__detail-neg">- ${toMoney(d.total_allocated_amount)}</span></div>`);
    });
    return rows.join("");
  }

  function renderFooter() {
    if (!state.cart) return "";
    const subtotal = state.cart.total_price || 0;
    const compareTotal = (state.cart.items || []).reduce((sum, item) => {
      const sale = getLineItemUnitSaleCents(item);
      const compare = getLineItemUnitCompareCents(item, sale);
      return sum + (compare > sale ? compare : sale) * (Number(item.quantity) || 0);
    }, 0);
    const full = compareTotal > subtotal ? compareTotal : 0;
    return `
      <div class="SCS_cart_01__details ${state.detailsOpen ? "is-open" : ""}">${getSavingsRows()}</div>
      <div class="SCS_cart_01__checkout-row">
        <span class="SCS_cart_01__totals-left">
          <span class="SCS_cart_01__subtotal-label">Total</span>
          <button class="SCS_cart_01__show-details" type="button" data-action="toggle-details">${state.detailsOpen ? "Hide Details" : "Show Details"}</button>
        </span>
        <span class="SCS_cart_01__subtotal">${full > 0 ? `<span class="SCS_cart_01__full">${toMoney(full)}</span>` : ""}${toMoney(subtotal)}</span>
      </div>
      <button type="button" class="SCS_cart_01__checkout-btn" data-action="checkout">\ud83d\udd12 Secure Checkout</button>
      <div class="SCS_cart_01__badges">
        <img src="https://cdn.shopify.com/s/files/1/0732/5909/0212/files/payment-badges.png?v=1781252396" alt="Payment badges">
      </div>
    `;
  }

  function parseRebuyMoney(value) {
    if (value == null || value === "") return 0;
    if (typeof value === "number") return value > 1000 ? value : Math.round(value * 100);
    const parsed = parseFloat(String(value).replace(/[^0-9.-]/g, ""));
    return Number.isFinite(parsed) ? Math.round(parsed * 100) : 0;
  }

  function normalizeRebuyProduct(p, idx) {
    if (!p) return null;
    const variant = p.selected_variant || p.variants?.[0];
    const variantId = variant?.id || p.variant_id || p.variantId;
    const title = p.title || p.product_title || p.name;
    const image = p.image?.src || p.image || p.featured_image || p.images?.[0]?.src || p.image_url;
    if (!variantId || !title) return null;
    const price = parseRebuyMoney(variant?.price ?? p.price ?? p.price_cents);
    const compareAt = parseRebuyMoney(variant?.compare_at_price ?? p.compare_at_price ?? p.compareAt);
    return {
      uid: `${variantId}-${idx}`,
      variantId: Number(variantId),
      title: String(title),
      image: typeof image === "string" ? image : image?.src || "",
      price,
      compareAt: compareAt > price ? compareAt : 0,
    };
  }

  function normalizeRebuyDealProduct(p) {
    if (!p) return null;
    const mapVariant = (variant) => ({
      id: variant.id,
      title: variant.title,
      option1: variant.option1,
      option2: variant.option2,
      option3: variant.option3,
      public_title: variant.public_title,
      price: parseRebuyMoney(variant.price),
      compare_at_price: parseRebuyMoney(variant.compare_at_price),
    });

    let variants = Array.isArray(p.variants) ? p.variants.map(mapVariant).filter((v) => v.id) : [];
    if (!variants.length && p.selected_variant?.id) {
      variants = [mapVariant(p.selected_variant)];
    }

    const image = p.image?.src || p.image || p.featured_image || p.images?.[0]?.src || p.image_url;
    return {
      handle: p.handle || p.product_handle || "",
      title: p.title || p.product_title || p.name || "",
      featured_image: typeof image === "string" ? image : image?.src || "",
      variants,
    };
  }

  function syncDealFromRebuyWidget() {
    if (state.deal.product?.variants?.length) {
      syncDealFromProduct(state.deal.product);
      return true;
    }

    const widget = findRebuyWidget(REBUY_DEAL_WIDGET_ID);
    if (!widget) return false;
    applyCartContextToWidget(widget);
    const products = widget.data?.products;
    if (!Array.isArray(products) || !products.length) return false;
    const product = pickDealProductFromRebuyProducts(products);
    if (!product?.variants?.length) return false;
    setDealProduct(product);
    return true;
  }

  function getRebuyApiKey() {
    return cfg.rebuyApiKey || window.Rebuy?.shop?.api_key || window.Rebuy?.shop?.apiKey || "";
  }

  function findRebuyWidget(widgetId = REBUY_UPSELL_WIDGET_ID) {
    const widgets = window.Rebuy?.widgets || [];
    return widgets.find((w) => String(w.id) === String(widgetId)) || null;
  }

  function ensureRebuyWidgetHost(widgetId = REBUY_UPSELL_WIDGET_ID) {
    if (!root) return null;
    let host = root.querySelector(`[data-rebuy-id="${widgetId}"]`);
    if (!host) {
      host = document.createElement("div");
      host.className = "SCS_cart_01__rebuy-host";
      host.setAttribute("data-rebuy-id", widgetId);
      host.setAttribute("aria-hidden", "true");
      host.hidden = true;
      root.appendChild(host);
      if (typeof window.Rebuy?.init === "function") {
        try {
          window.Rebuy.init();
        } catch (err) {
          console.warn("[SCS_CART_01] Rebuy.init failed:", err);
        }
      }
    }
    return host;
  }

  function getRebuyCartSignature() {
    return (state.cart?.items || []).map((item) => `${item.variant_id}:${item.quantity}`).join("|");
  }

  function bindRebuyWidgetWatcher(widget) {
    if (!widget || widget.__SCS_CART_01_WATCHING__) return;
    widget.__SCS_CART_01_WATCHING__ = true;
    if (typeof widget.watchCart !== "function") return;
    try {
      widget.watchCart(() => {
        syncRebuyFromWidget();
        scheduleCartRefreshFromRebuy();
      });
    } catch (err) {
      console.warn("[SCS_CART_01] widget.watchCart failed:", err);
    }
  }

  function bindRebuyDealWidgetWatcher(widget) {
    if (!widget || widget.__SCS_CART_01_DEAL_WATCHING__) return;
    widget.__SCS_CART_01_DEAL_WATCHING__ = true;
    if (typeof widget.watchCart !== "function") return;
    try {
      widget.watchCart(() => {
        scheduleCartRefreshFromRebuy();
      });
    } catch (err) {
      console.warn("[SCS_CART_01] deal widget.watchCart failed:", err);
    }
  }

  function waitForRebuyWidget(widgetId = REBUY_UPSELL_WIDGET_ID, timeout = 8000) {
    return new Promise((resolve) => {
      const immediate = findRebuyWidget(widgetId);
      if (immediate) {
        if (String(widgetId) === REBUY_UPSELL_WIDGET_ID) bindRebuyWidgetWatcher(immediate);
        if (String(widgetId) === REBUY_DEAL_WIDGET_ID) bindRebuyDealWidgetWatcher(immediate);
        resolve(immediate);
        return;
      }

      if (String(widgetId) === REBUY_UPSELL_WIDGET_ID) ensureRebuyWidgetHost(widgetId);

      let settled = false;
      const finish = (widget) => {
        if (settled) return;
        settled = true;
        document.removeEventListener("rebuy.ready", onReady);
        clearInterval(poll);
        clearTimeout(timer);
        if (widget) {
          if (String(widgetId) === REBUY_UPSELL_WIDGET_ID) bindRebuyWidgetWatcher(widget);
          if (String(widgetId) === REBUY_DEAL_WIDGET_ID) bindRebuyDealWidgetWatcher(widget);
        }
        resolve(widget || null);
      };

      const onReady = (event) => {
        const widget = event.detail?.widget;
        if (widget && String(widget.id) === String(widgetId)) finish(widget);
      };

      document.addEventListener("rebuy.ready", onReady);
      const poll = setInterval(() => {
        const widget = findRebuyWidget(widgetId);
        if (widget) finish(widget);
      }, 250);
      const timer = setTimeout(() => finish(findRebuyWidget(widgetId)), timeout);
    });
  }

  function applyCartContextToWidget(widget) {
    if (!widget?.data || !state.cart?.items?.length) return;
    widget.data.shopify_variant_ids = state.cart.items.map((item) => item.variant_id).filter(Boolean);
    widget.data.shopify_product_ids = state.cart.items.map((item) => item.product_id).filter(Boolean);
  }

  function fetchProductsFromWidget(widget, timeoutMs = 5000) {
    return new Promise((resolve) => {
      if (!widget) {
        resolve([]);
        return;
      }
      applyCartContextToWidget(widget);
      const existing = widget.data?.products;
      if (typeof widget.getWidgetProducts !== "function") {
        resolve(Array.isArray(existing) ? existing : []);
        return;
      }
      let settled = false;
      const finish = (products) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve(Array.isArray(products) ? products : []);
      };
      const timer = setTimeout(() => finish(widget.data?.products || existing || []), timeoutMs);
      try {
        widget.getWidgetProducts(() => {
          finish(widget.data?.products || existing || []);
        });
      } catch (err) {
        console.warn("[SCS_CART_01] getWidgetProducts failed:", err);
        finish(existing || []);
      }
    });
  }

  async function fetchProductsFromRebuyApi(widget) {
    const apiKey = getRebuyApiKey();
    if (!apiKey) return [];

    const params = new URLSearchParams({
      key: apiKey,
      limit: String(cfg.rebuyLimit || 8),
      filter_oos: "yes",
    });

    const cart = state.cart;
    if (cart?.items?.length) {
      cart.items.forEach((item, i) => {
        params.append(`cart[items][${i}][product_id]`, String(item.product_id));
        params.append(`cart[items][${i}][variant_id]`, String(item.variant_id));
        params.append(`cart[items][${i}][quantity]`, String(item.quantity));
      });
      const variantIds = cart.items.map((item) => item.variant_id).filter(Boolean).join(",");
      if (variantIds) params.set("shopify_variant_ids", variantIds);
    }

    const rulesetId =
      cfg.rebuyRulesetId ||
      cfg.rebuyDataSourceId ||
      widget?.data?.metadata?.ruleset_id ||
      widget?.data?.settings?.ruleset_id ||
      widget?.data?.settings?.data_source_id;

    const url = rulesetId
      ? `https://rebuyengine.com/api/v1/custom/id/${rulesetId}?${params}`
      : `https://rebuyengine.com/api/v1/products/recommended?${params}`;

    try {
      const res = await fetch(url, { credentials: "omit" });
      if (!res.ok) return [];
      const json = await res.json();
      return json.data || [];
    } catch (err) {
      console.warn("[SCS_CART_01] Rebuy API fetch failed:", err);
      return [];
    }
  }

  function applyRebuyRecommendations(products) {
    const excludedVariantIds = getExcludedUpsellVariantIds();
    state.recommendations = products
      .filter((p) => !isUpsellExcludedRebuyProduct(p))
      .map((p, i) => normalizeRebuyProduct(p, i))
      .filter(Boolean)
      .filter((item) => !excludedVariantIds.has(item.variantId))
      .slice(0, cfg.rebuyLimit || 8);
  }

  function hydrateRebuyRecommendationsFallback() {
    let products = [];
    const rb = window.Rebuy || window.rebuy;
    if (Array.isArray(rb?.smart_cart?.recommended_products)) products = rb.smart_cart.recommended_products;
    if (!products.length && Array.isArray(rb?.recommendations)) products = rb.recommendations;
    if (!products.length && Array.isArray(cfg.rebuyRecommendations)) products = cfg.rebuyRecommendations;
    applyRebuyRecommendations(products);
  }

  function syncRebuyFromWidget() {
    const widget = findRebuyWidget(REBUY_UPSELL_WIDGET_ID);
    if (!widget) return false;
    applyCartContextToWidget(widget);
    const products = widget.data?.products;
    if (!Array.isArray(products) || !products.length) return false;
    applyRebuyRecommendations(products);
    state.rebuyLoading = false;
    syncUpsellSection();
    return state.recommendations.length > 0;
  }

  function syncUpsellSection() {
    if (!refs?.body || !state.cart?.items?.length) return;
    const html = renderUpsellSection();
    const existing = refs.body.querySelector(".SCS_cart_01__suggested");
    if (!html) {
      existing?.remove();
    } else if (existing) {
      existing.outerHTML = html;
    } else {
      refs.body.insertAdjacentHTML("beforeend", html);
    }
    lastRenderKey = getRenderKey();
  }

  function scheduleRebuyLoad(options = {}) {
    const force = options.force === true;
    const cartSig = getRebuyCartSignature();
    if (cartSig !== rebuyCartSignature) {
      rebuyCartSignature = cartSig;
      rebuyFetchPromise = null;
      rebuyLoadGeneration += 1;
    }

    if (syncRebuyFromWidget()) {
      if (!force && state.recommendations.length) {
        if (!rebuyFetchPromise) {
          rebuyFetchPromise = loadRebuyRecommendations({ background: true }).finally(() => {
            rebuyFetchPromise = null;
          });
        }
        return rebuyFetchPromise;
      }
      return Promise.resolve();
    }

    const showSkeleton = options.showSkeleton !== false && !state.recommendations.length;

    if (!force && state.recommendations.length) {
      if (rebuyFetchPromise) return rebuyFetchPromise;
      rebuyFetchPromise = loadRebuyRecommendations({ background: true }).finally(() => {
        rebuyFetchPromise = null;
      });
      return rebuyFetchPromise;
    }

    if (rebuyFetchPromise) return rebuyFetchPromise;

    if (showSkeleton) {
      state.rebuyLoading = true;
      syncUpsellSection();
    }

    rebuyFetchPromise = loadRebuyRecommendations({ showSkeleton }).finally(() => {
      rebuyFetchPromise = null;
    });

    if (showSkeleton) {
      const loadToken = rebuyLoadGeneration;
      setTimeout(() => {
        if (loadToken !== rebuyLoadGeneration) return;
        if (!state.rebuyLoading || state.recommendations.length) return;
        state.rebuyLoading = false;
        syncUpsellSection();
      }, 12000);
    }

    return rebuyFetchPromise;
  }

  function prefetchRebuy() {
    ensureRebuyWidgetHost(REBUY_UPSELL_WIDGET_ID);
    ensureRebuyWidgetHost(REBUY_DEAL_WIDGET_ID);
    void waitForRebuyWidget(REBUY_UPSELL_WIDGET_ID, 8000).then((widget) => {
      if (widget && state.cart) scheduleRebuyLoad({ force: true, showSkeleton: !state.recommendations.length });
    });
    void waitForRebuyWidget(REBUY_DEAL_WIDGET_ID, 8000).then((widget) => {
      if (widget && state.cart) scheduleDealLoad();
    });
  }

  async function loadRebuyRecommendations(options = {}) {
    const background = options.background === true;
    const generation = rebuyLoadGeneration;

    const finishRebuyLoad = () => {
      if (generation !== rebuyLoadGeneration) return;
      state.rebuyLoading = false;
      syncUpsellSection();
    };

    if (background && state.recommendations.length) {
      try {
        let products = [];
        const widget = await waitForRebuyWidget(REBUY_UPSELL_WIDGET_ID, 4000);
        if (generation !== rebuyLoadGeneration) return;
        if (widget) products = await fetchProductsFromWidget(widget);
        if (!products.length) products = await fetchProductsFromRebuyApi(widget);
        if (generation !== rebuyLoadGeneration) return;
        if (products.length) applyRebuyRecommendations(products);
      } catch (err) {
        console.warn("[SCS_CART_01] background rebuy refresh failed:", err);
      } finally {
        if (generation === rebuyLoadGeneration) syncUpsellSection();
      }
      return;
    }

    try {
      let products = [];
      const widget = await waitForRebuyWidget(REBUY_UPSELL_WIDGET_ID);
      if (generation !== rebuyLoadGeneration) return;
      if (widget && syncRebuyFromWidget()) {
        return;
      }
      if (widget) products = await fetchProductsFromWidget(widget);
      if (generation !== rebuyLoadGeneration) return;
      if (!products.length) products = await fetchProductsFromRebuyApi(widget);
      if (generation !== rebuyLoadGeneration) return;
      if (!products.length) hydrateRebuyRecommendationsFallback();
      else applyRebuyRecommendations(products);
    } catch (err) {
      console.warn("[SCS_CART_01] loadRebuyRecommendations failed:", err);
      if (generation === rebuyLoadGeneration) hydrateRebuyRecommendationsFallback();
    } finally {
      finishRebuyLoad();
    }
  }

  function scrollUpsellCarousel(dir) {
    const track = root?.querySelector("#SCS_cart_01_upsell-track");
    if (track) track.scrollBy({ left: dir * track.clientWidth, behavior: "smooth" });
  }

  function setUpsellLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      if (!btn.dataset.scsUpsellContent) btn.dataset.scsUpsellContent = btn.innerHTML;
      btn.disabled = true;
      btn.classList.add("is-loading");
      btn.innerHTML = '<span class="SCS_cart_01__upsell-spinner" aria-hidden="true"></span>';
      return;
    }
    btn.disabled = false;
    btn.classList.remove("is-loading");
    if (btn.dataset.scsUpsellContent) {
      btn.innerHTML = btn.dataset.scsUpsellContent;
      delete btn.dataset.scsUpsellContent;
    }
  }

  function renderUpsellSection() {
    if (state.rebuyLoading && !state.recommendations.length) {
      return `
        <section class="SCS_cart_01__suggested">
          <div class="SCS_cart_01__suggested-header">
            <h3 class="SCS_cart_01__suggested-title">Often Purchased With</h3>
          </div>
          <div class="SCS_cart_01__suggested-skeleton">
            <div class="SCS_cart_01__skeleton-img"></div>
            <div class="SCS_cart_01__skeleton-lines">
              <div class="SCS_cart_01__skeleton-line SCS_cart_01__skeleton-line--title"></div>
              <div class="SCS_cart_01__skeleton-line"></div>
              <div class="SCS_cart_01__skeleton-checkout"></div>
            </div>
          </div>
        </section>`;
    }

    if (!state.recommendations.length) return "";

    const cards = state.recommendations
      .map(
        (item) => `
      <article class="SCS_cart_01__suggested-card">
        <img class="SCS_cart_01__suggested-img" src="${htmlEscape(item.image)}" alt="${htmlEscape(item.title)}">
        <div class="SCS_cart_01__suggested-details">
          <p class="SCS_cart_01__suggested-name">${htmlEscape(item.title)}</p>
          <div class="SCS_cart_01__suggested-price-row">
            ${item.compareAt ? `<span class="SCS_cart_01__suggested-compare">${toMoney(item.compareAt)}</span>` : ""}
            <span class="SCS_cart_01__suggested-sale">${toMoney(item.price)}</span>
          </div>
          <button type="button" class="SCS_cart_01__btn-add" data-action="add-upsell" data-variant-id="${item.variantId}">Add to Cart</button>
        </div>
      </article>`
      )
      .join("");

    const nav =
      state.recommendations.length > 1
        ? `
      <div class="SCS_cart_01__carousel-nav">
        <button type="button" class="SCS_cart_01__carousel-btn" data-action="upsell-prev" aria-label="Previous recommendation">&#8249;</button>
        <button type="button" class="SCS_cart_01__carousel-btn" data-action="upsell-next" aria-label="Next recommendation">&#8250;</button>
      </div>`
        : "";

    return `
      <section class="SCS_cart_01__suggested">
        <div class="SCS_cart_01__suggested-header">
          <h3 class="SCS_cart_01__suggested-title">Often Purchased With</h3>
          ${nav}
        </div>
        <div class="SCS_cart_01__suggested-track" id="SCS_cart_01_upsell-track">${cards}</div>
      </section>`;
  }

  function getRenderKey() {
    const cart = state.cart;
    if (!cart) return `loading:${state.loading}`;
    const itemsKey = (cart.items || []).map((item) => {
      const sale = getLineItemUnitSaleCents(item);
      const compare = getLineItemUnitCompareCents(item, sale);
      return `${item.key}:${item.quantity}:${sale}:${compare}`;
    }).join("|");
    return [
      cart.item_count,
      cart.total_price,
      cart.original_total_price,
      itemsKey,
      state.deal.expanded,
      state.deal.fit,
      state.deal.prices.car,
      state.deal.prices.truck,
      state.deal.compareAts.car,
      state.deal.compareAts.truck,
      getDealTitle(),
      state.detailsOpen,
      getSeatItems().length,
      state.recommendations.length,
      state.rebuyLoading,
    ].join("::");
  }

  function renderSkeleton() {
    refs.title.textContent = "Your Cart";
    refs.body.innerHTML = `
      <div class="SCS_cart_01__skeleton" aria-hidden="true">
        <div class="SCS_cart_01__skeleton-banner"></div>
        ${[1, 2].map(() => `
          <div class="SCS_cart_01__skeleton-item">
            <div class="SCS_cart_01__skeleton-img"></div>
            <div class="SCS_cart_01__skeleton-lines">
              <div class="SCS_cart_01__skeleton-line SCS_cart_01__skeleton-line--title"></div>
              <div class="SCS_cart_01__skeleton-line"></div>
              <div class="SCS_cart_01__skeleton-line SCS_cart_01__skeleton-line--short"></div>
              <div class="SCS_cart_01__skeleton-stepper"></div>
            </div>
          </div>
        `).join("")}
      </div>`;
    refs.footer.innerHTML = `
      <div class="SCS_cart_01__skeleton-footer">
        <div class="SCS_cart_01__skeleton-line SCS_cart_01__skeleton-line--footer"></div>
        <div class="SCS_cart_01__skeleton-checkout"></div>
      </div>`;
    setRefreshUi();
  }

  function render(force = false) {
    if (!refs) return;

    if (shouldShowCartSkeleton()) {
      if (!force && lastRenderKey === "__skeleton__") return;
      lastRenderKey = "__skeleton__";
      renderSkeleton();
      return;
    }

    const cart = state.cart;
    if (!cart || !cart.items || cart.items.length === 0) {
      const emptyKey = "empty";
      if (!force && lastRenderKey === emptyKey) {
        setRefreshUi();
        return;
      }
      lastRenderKey = emptyKey;
      refs.title.textContent = "Your Cart (0 Items)";
      refs.body.innerHTML = '<p class="SCS_cart_01__empty">Your cart is empty.</p>';
      refs.footer.innerHTML = '<div class="SCS_cart_01__empty-block"></div>';
      setRefreshUi();
      return;
    }

    const renderKey = getRenderKey();
    if (!force && renderKey === lastRenderKey) {
      setRefreshUi();
      return;
    }
    lastRenderKey = renderKey;

    const regular = getRegularItems();
    const gifts = getGiftItems();
    const lineItemsHtml = regular.map((item) => renderLineItem(item)).join("");
    const giftHtml = gifts.map((item) => renderGiftCard(item)).join("");
    const dealHtml = renderDealSection();

    refs.title.textContent = `Your Cart (${cart.item_count} Items)`;
    refs.body.innerHTML = `
      <div class="SCS_cart_01__products-group">
        <div class="SCS_cart_01__line-items-group">
          ${renderShippingBanner()}
          <div class="SCS_cart_01__line-items">${lineItemsHtml}</div>
        </div>
        <div class="SCS_cart_01__gifts-deal-group">
          ${giftHtml}
          ${dealHtml}
        </div>
      </div>
      ${renderUpsellSection()}
    `;
    refs.footer.innerHTML = renderFooter();
    setRefreshUi();
  }

  function showToast(message) {
    const current = document.querySelector(".SCS_cart_01__toast");
    if (current) current.remove();
    const el = document.createElement("div");
    el.className = "SCS_cart_01__toast";
    el.textContent = message;
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 2500);
  }

  const BODY_OPEN_CLASS = "scs-cart-01-open";
  const MICRO_APP_SELECTOR = ".rp-micro-app-dummy-icon-container";
  const microAppZIndexState = new WeakMap();

  function setMicroAppLayer(open) {
    document.querySelectorAll(MICRO_APP_SELECTOR).forEach((el) => {
      if (open) {
        if (!microAppZIndexState.has(el)) {
          microAppZIndexState.set(el, {
            inline: el.style.zIndex,
            priority: el.style.getPropertyPriority("z-index"),
            computed: window.getComputedStyle(el).zIndex,
          });
        }
        el.style.setProperty("z-index", "0", "important");
        return;
      }

      if (!microAppZIndexState.has(el)) return;
      const prev = microAppZIndexState.get(el);
      if (prev.inline) {
        el.style.setProperty("z-index", prev.inline, prev.priority || "");
      } else {
        el.style.removeProperty("z-index");
      }
      microAppZIndexState.delete(el);
    });
  }

  function openCart() {
    if (!root) return;
    root.classList.remove("is-closed");
    root.classList.add("is-open");
    document.body.classList.add(BODY_OPEN_CLASS);
    document.body.classList.add("overflow-hidden");
    document.body.style.overflow = "hidden";
    setMicroAppLayer(true);
  }

  function closeCart() {
    if (!root) return;
    closingCart = true;
    root.classList.add("is-closed");
    root.classList.remove("is-open");
    document.body.classList.remove(BODY_OPEN_CLASS);
    document.body.classList.remove("overflow-hidden");
    document.body.style.overflow = "";
    setMicroAppLayer(false);
    setTimeout(() => {
      closingCart = false;
    }, 0);
  }

  const CART_TRIGGER_SELECTOR = [
    "#cart-icon-bubble",
    ".header__icon--cart",
    "[data-cart-open]",
    "[aria-controls='CartDrawer']",
    "a[href*='/cart']",
  ].join(",");

  function isCartTrigger(trigger) {
    if (!trigger || !root || root.contains(trigger)) return false;
    if (trigger.matches("#cart-icon-bubble, .header__icon--cart, [data-cart-open], [aria-controls='CartDrawer']")) {
      return true;
    }
    if (trigger.matches("a[href*='/cart']")) {
      return Boolean(
        trigger.closest("header, .header, sticky-header, #shopify-section-header, .shopify-section-header")
      );
    }
    return false;
  }

  let openingCart = false;

  async function openCartAndRefresh() {
    if (openingCart || !root) return;
    openingCart = true;
    closeNativeCart();

    const hasCart = cartHasVisibleItems();
    if (!hasCart) {
      state.loading = true;
      render(true);
    }

    openCart();

    try {
      await fetchCart({ silent: hasCart });
    } finally {
      openingCart = false;
    }
  }

  function handleCartTriggerEvent(event) {
    const trigger = event.target.closest(CART_TRIGGER_SELECTOR);
    if (!isCartTrigger(trigger)) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openCartAndRefresh();
  }

  const CART_TRIGGER_EVENTS = ["mousedown", "click", "pointerup", "touchend"];

  function bindCartTriggerElement(el) {
    if (!el || el.dataset.scsCart01Bound === "1" || root.contains(el)) return;
    el.dataset.scsCart01Bound = "1";
    CART_TRIGGER_EVENTS.forEach((type) => {
      el.addEventListener(type, handleCartTriggerEvent, true);
    });
  }

  function bindCartTriggerElements() {
    document.querySelectorAll("#cart-icon-bubble, .header__icon--cart, [data-cart-open]").forEach(bindCartTriggerElement);
    document.querySelectorAll("a[href*='/cart']").forEach((el) => {
      if (isCartTrigger(el)) bindCartTriggerElement(el);
    });
  }

  function bindGlobalCartTriggers() {
    CART_TRIGGER_EVENTS.forEach((type) => {
      document.addEventListener(type, handleCartTriggerEvent, true);
    });
    bindCartTriggerElements();
    const triggerObserver = new MutationObserver(bindCartTriggerElements);
    if (document.body) {
      triggerObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  function hideNativeCart() {
    [
      "cart-drawer",
      "#CartDrawer",
      ".cart-drawer",
      "cart-notification",
      "#cart-notification",
      "#rebuy-cart",
      ".rebuy-cart",
    ].forEach((selector) => {
      document.querySelectorAll(selector).forEach((node) => {
        if (!root.contains(node)) {
          node.style.setProperty("display", "none", "important");
          node.style.setProperty("visibility", "hidden", "important");
          node.style.setProperty("pointer-events", "none", "important");
        }
      });
    });
  }

  function closeNativeCart() {
    hideNativeCart();
    try {
      window.Rebuy?.SmartCart?.hide?.();
    } catch (err) {
      console.error(err);
    }
    document.querySelectorAll("cart-drawer").forEach((drawer) => {
      if (drawer.__SCS_CART_01_NATIVE_CLOSE__) {
        drawer.__SCS_CART_01_NATIVE_CLOSE__.call(drawer);
      } else if (typeof drawer.close === "function") {
        drawer.close();
      }
      drawer.classList.remove("active");
      drawer.removeAttribute("open");
    });
  }

  function hijackNativeCartDrawer() {
    const patchDrawer = (drawer) => {
      if (!drawer || drawer.__SCS_CART_01_DRAWER_PATCHED__) return;
      drawer.__SCS_CART_01_DRAWER_PATCHED__ = true;

      if (typeof drawer.open === "function" && !drawer.__SCS_CART_01_NATIVE_OPEN__) {
        drawer.__SCS_CART_01_NATIVE_OPEN__ = drawer.open.bind(drawer);
        drawer.open = () => {
          closeNativeCart();
          openCartAndRefresh();
        };
      }

      if (typeof drawer.close === "function" && !drawer.__SCS_CART_01_NATIVE_CLOSE__) {
        drawer.__SCS_CART_01_NATIVE_CLOSE__ = drawer.close.bind(drawer);
        drawer.close = (...args) => {
          drawer.__SCS_CART_01_NATIVE_CLOSE__(...args);
          if (root?.classList.contains("is-open")) closeCart();
        };
      }
    };

    document.querySelectorAll("cart-drawer").forEach(patchDrawer);
    const drawerObserver = new MutationObserver(() => {
      document.querySelectorAll("cart-drawer").forEach(patchDrawer);
    });
    if (document.body) {
      drawerObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  function watchBodyOverflowTrap() {
    const rescueOpen = () => {
      if (closingCart || bootstrapping || !root) return;
      if (!document.body.classList.contains("overflow-hidden")) return;
      if (root.classList.contains("is-open")) return;
      closeNativeCart();
      openCartAndRefresh();
    };

    const observer = new MutationObserver(rescueOpen);
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
  }

  function hijackRebuySmartCart() {
    const patch = () => {
      const smartCart = window.Rebuy?.SmartCart;
      if (!smartCart || smartCart.__SCS_CART_01_PATCHED__) return;
      smartCart.__SCS_CART_01_PATCHED__ = true;
      smartCart.show = () => {
        closeNativeCart();
        if (!bootstrapping) openCartAndRefresh();
      };
    };

    patch();
    const wait = (attempts = 40) => {
      patch();
      if (!window.Rebuy?.SmartCart?.__SCS_CART_01_PATCHED__ && attempts > 0) {
        setTimeout(() => wait(attempts - 1), 250);
      }
    };
    wait();

    document.addEventListener(
      "rebuy:smartcart.show",
      () => {
        closeNativeCart();
        if (!bootstrapping) openCartAndRefresh();
      },
      true
    );
  }

  function bindRebuyEvents() {
    if (window.__SCS_CART_01_REBUY_BOUND__) return;
    window.__SCS_CART_01_REBUY_BOUND__ = true;

    const onRebuyProductsReady = () => {
      if (syncRebuyFromWidget()) return;
      scheduleRebuyLoad({ force: true, showSkeleton: !state.recommendations.length });
    };

    const onRebuyDealReady = () => {
      scheduleDealLoad();
    };

    document.addEventListener("rebuy.ready", (event) => {
      const widget = event.detail?.widget;
      if (!widget) return;
      const id = String(widget.id);
      if (id === REBUY_UPSELL_WIDGET_ID) {
        bindRebuyWidgetWatcher(widget);
        onRebuyProductsReady();
      } else if (id === REBUY_DEAL_WIDGET_ID) {
        bindRebuyDealWidgetWatcher(widget);
        onRebuyDealReady();
      }
    });
    document.addEventListener("rebuy.loaded", () => {
      onRebuyProductsReady();
      onRebuyDealReady();
    });
    document.addEventListener("rebuy:cart.change", () => {
      scheduleCartRefreshFromRebuy();
      scheduleDealLoad();
      if (syncRebuyFromWidget()) return;
      scheduleRebuyLoad({ force: false });
    });
  }

  function bindAddToCartOpen() {
    let opening = false;
    const onAdded = () => {
      if (opening) return;
      opening = true;
      if (root?.classList.contains("is-open")) {
        state.refreshing = true;
        setRefreshUi();
        void pullCartFromServer(true).finally(() => {
          state.refreshing = false;
          setRefreshUi();
          opening = false;
        });
        return;
      }
      void openCartAndRefresh().finally(() => {
        opening = false;
      });
    };

    ["rebuy:cart.add", "cart:added"].forEach((eventName) => {
      document.addEventListener(eventName, onAdded);
    });

    const originalFetch = window.fetch.bind(window);
    window.fetch = (...args) => {
      const response = originalFetch(...args);
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
      if (/\/cart\/add(\.js)?/.test(url)) {
        response
          .then((res) => {
            if (res?.ok) onAdded();
          })
          .catch(() => {});
      }
      return response;
    };
  }

  function watchNativeCart() {
    const observer = new MutationObserver(() => {
      hideNativeCart();
      if (document.querySelector(".rebuy-cart.is-visible, #rebuy-cart.is-visible")) {
        closeNativeCart();
      }
      if (root?.classList.contains("is-open")) {
        setMicroAppLayer(true);
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style", "open"],
    });
  }

  function bindRootEvents() {
    if (!root || root.dataset.scsCart01EventsBound === "1") return;
    root.dataset.scsCart01EventsBound = "1";
    root.addEventListener("click", async (event) => {
      const actionEl = event.target.closest("[data-action]");
      if (!actionEl) return;
      const action = actionEl.dataset.action;
      if ((shouldShowCartSkeleton() || state.refreshing) && action !== "close-cart" && action !== "overlay-close" && action !== "checkout") return;

      if (action === "close-cart" || action === "overlay-close") return closeCart();
      if (action === "toggle-details") {
        state.detailsOpen = !state.detailsOpen;
        return render(true);
      }
      if (action === "qty-down" || action === "qty-up") {
        const line = Number(actionEl.dataset.line || 0);
        const item = state.cart?.items?.[line - 1];
        if (!item || isGiftItem(item) || actionEl.disabled) return;
        const qty = action === "qty-down" ? Math.max(0, item.quantity - 1) : item.quantity + 1;
        return changeLine(line, qty, actionEl);
      }
      if (action === "set-fit") {
        state.deal.fit = actionEl.dataset.fit || "car";
        return render(true);
      }
      if (action === "toggle-deal") {
        state.deal.expanded = !state.deal.expanded;
        return syncDealDom();
      }
      if (action === "claim-deal") {
        return toggleDealClaim();
      }
      if (action === "upsell-prev") return scrollUpsellCarousel(-1);
      if (action === "upsell-next") return scrollUpsellCarousel(1);
      if (action === "add-upsell") {
        setUpsellLoading(actionEl, true);
        try {
          await addVariant(actionEl.dataset.variantId, 1, REBUY_UPSELL_WIDGET_ID);
        } finally {
          setUpsellLoading(actionEl, false);
        }
        return;
      }
      if (action === "checkout") {
        if (actionEl.disabled) return;
        window.location.href = "/checkout";
        return;
      }
    });
  }

  function boot() {
    if (window.__SCS_CART_01_INITIALIZED__ && document.getElementById(ROOT_ID)) return;
    if (!document.body) return;

    try {
    root = ensureMount();
    if (!root) return;

    refs = {
      title: document.getElementById("SCS_cart_01_title"),
      body: document.getElementById("SCS_cart_01_body"),
      footer: document.getElementById("SCS_cart_01_footer"),
    };

    bindRootEvents();
    closeCart();
    bindGlobalCartTriggers();
    hijackNativeCartDrawer();
    hijackRebuySmartCart();
    bindAddToCartOpen();
    bindRebuyEvents();
    prefetchRebuy();
    hideNativeCart();
    watchNativeCart();
    watchBodyOverflowTrap();
    fetchCart({ silent: false });

    window.__SCS_CART_01_INITIALIZED__ = true;
    window.SCS_CART_01 = { open: openCartAndRefresh, close: closeCart };
    setTimeout(() => {
      bootstrapping = false;
    }, 1500);
    } catch (err) {
      console.error("[SCS_cart_01] boot failed:", err);
    }
  }

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
      return;
    }
    fn();
  }

  onReady(() => {
    if (window.EV_CART_DRAWER) boot();
  });
})();
